/**
 * @description Примесь диалога.
 */
export const popoverMixin = {
  data() {
    return {
      isShown: this.initialShown,
    };
  },
  methods: {
    close() {
      this.onInput(false);
    },
    onInput(value) {
      this.isShown = value;
      this.$emit('input', value);
    },
  },
  provide() {
    return { closePopover: this.close };
  },
  props: {
    initialShown: { default: () => false, type: Boolean },
  },
};

/**
 * @description Примесь встраиваемого компонента в диалог.
 */
export const builtInPopoverMixin = {
  inject: ['closePopover'],
};

export default builtInPopoverMixin;
